var _defs, _circle, _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgCorazon(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Ico_coraz\\xF3n_Emg",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 83.066,
    height: 77.066,
    viewBox: "0 0 83.066 77.066",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path"
  }, /*#__PURE__*/React.createElement("path", {
    id: "path2784",
    d: "M0-682.665H77.066V-605.6H0Z",
    transform: "translate(0 682.665)"
  })))), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    id: "Elipse_1603",
    "data-name": "Elipse 1603",
    cx: 15,
    cy: 15,
    r: 15,
    transform: "translate(0 37.911)",
    fill: "#7eccc9",
    opacity: 0.5
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "g2778",
    transform: "translate(6 682.665)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "g2780",
    transform: "translate(0 -682.665)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "g2782",
    transform: "translate(0 0)",
    clipPath: "url(#clip-path)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "g2788",
    transform: "translate(37.601 10.215)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "path2790",
    d: "M-206.593,0c-4.8,0-8.572,4-8.572,4s-3.553-4-8.573-4c-4.882,0-8.868,4.5-9.129,9.944a12.961,12.961,0,0,0,1.992,7.539c2.5,4.237,15.726,12.832,15.726,12.832s13.178-8.558,15.694-12.832a12.958,12.958,0,0,0,1.992-7.539C-197.725,4.5-201.711,0-206.593,0",
    transform: "translate(232.883)",
    fill: "#ee2b7c"
  })), /*#__PURE__*/React.createElement("g", {
    id: "g2792",
    transform: "translate(43.2 54.522)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "path2794",
    d: "M-108.034,0h-13.748",
    transform: "translate(121.782)",
    fill: "none",
    stroke: "#020288",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2.5
  })), /*#__PURE__*/React.createElement("g", {
    id: "g2796",
    transform: "translate(14.904 41.182)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "path2798",
    d: "M-469.3-57h0a4.633,4.633,0,0,0-6.262-1.207l-11.416,7.295c.3-.2,2.989-8.818-5.949-8.818h-4.3A22.269,22.269,0,0,1-506.935-62c-4.706-2.28-9.439-3.05-12.4-1.251a28.478,28.478,0,0,0-6.041,5.051h-3.655v10.832s10.022-2.893,12.221,1.491c3.516,7.012,29.823,7.5,36.837,2.333l9.521-6.566A4.9,4.9,0,0,0-469.3-57Z",
    transform: "translate(529.027 64.248)",
    fill: "none",
    stroke: "#3b0310",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2.5
  })), /*#__PURE__*/React.createElement("path", {
    id: "path2800",
    d: "M13.333-264.245h13.4V-280.6h-13.4Z",
    transform: "translate(-11.828 325.985)",
    fill: "none",
    stroke: "#3b0310",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2.5
  }))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCorazon);
export default __webpack_public_path__ + "static/media/corazon.1f09ed8e90d94551bc016a6974ad5b0e.svg";
export { ForwardRef as ReactComponent };